// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.course-filter fieldset {
  max-width: 230px;
}

.totalprogress path.highcharts-point.highcharts-color-0 {
  fill: var(--primaryColor);
}

.totalprogress path.highcharts-color-1 {
  fill: #9d9c9c;
}

.filter-select fieldset {
  border: none !important;
}

.filter-sort-select fieldset {
  height: 43px;
  max-height: 43px;
  margin: 6px 0;
}

.filter-sort-select fieldset legend {
  display: none;
}

.cardview-courselist .MuiCardActions-root .MuiButton-endIcon {
  margin-right: 4px;
  margin-left: 0;
}

.learningActivityCard div.MuiChip-root:first-of-type {
    margin-bottom: 4px;
}

.learning-courselist-item div.MuiChip-root {
    margin-right: 4px;
}

.learning-courselist {
  overflow: hidden;
}

.panel-courses .learning-courselist-item-image,
.learning-courselist .MuiAccordionSummary-expandIconWrapper {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./js/lib/components/MyLearning/style.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf","sourcesContent":[".course-filter fieldset {\r\n  max-width: 230px;\r\n}\r\n\r\n.totalprogress path.highcharts-point.highcharts-color-0 {\r\n  fill: var(--primaryColor);\r\n}\r\n\r\n.totalprogress path.highcharts-color-1 {\r\n  fill: #9d9c9c;\r\n}\r\n\r\n.filter-select fieldset {\r\n  border: none !important;\r\n}\r\n\r\n.filter-sort-select fieldset {\r\n  height: 43px;\r\n  max-height: 43px;\r\n  margin: 6px 0;\r\n}\r\n\r\n.filter-sort-select fieldset legend {\r\n  display: none;\r\n}\r\n\r\n.cardview-courselist .MuiCardActions-root .MuiButton-endIcon {\r\n  margin-right: 4px;\r\n  margin-left: 0;\r\n}\r\n\r\n.learningActivityCard div.MuiChip-root:first-of-type {\r\n    margin-bottom: 4px;\r\n}\r\n\r\n.learning-courselist-item div.MuiChip-root {\r\n    margin-right: 4px;\r\n}\r\n\r\n.learning-courselist {\r\n  overflow: hidden;\r\n}\r\n\r\n.panel-courses .learning-courselist-item-image,\r\n.learning-courselist .MuiAccordionSummary-expandIconWrapper {\r\n  display: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
